import { Icon } from "@iconify/react";
import { Link } from "@inertiajs/react";
import { useTranslation } from "react-i18next";

const FrontPagination = ({ links }) => {
    const { t, i18n } = useTranslation();

    const resolveActiveClass = (active) => {
        if (active) {
            return "mx-1 md:mx-3 border-[1px] border-dark-blue-standard rounded-full w-11 h-11 flex items-center justify-center bg-dark-blue-standard text-white";
        } else {
            return "mx-1 md:mx-3 border-[1px] border-dark-blue-standard rounded-full w-11 h-11 flex items-center justify-center text-dark-blue hover:bg-dark-blue-standard hover:text-white transition-all ease-in-out duration-300";
        }
    }

    if(links.length > 3){
        return (
            <div className="flex justify-center my-20">
                {links.map((link, id) => {
                    if (link.url) {
                        let urlWithParam = new URL(link.url);
                        let params = new URLSearchParams(urlWithParam.search);
                        if (params.get('page') === "1") {
                            params.delete('page');
                            
                            link.url = `${urlWithParam.origin}${urlWithParam.pathname}?${params}`;
                        }
                    }

                    if (link.label === '...') {
                        return (
                            <div key={id} className="mx-1 md:mx-3 border-[1px] border-dark-blue-standard rounded-full w-11 h-11 flex items-center justify-center">
                                <span className="text-18 font-bold text-dark-blue">{link.label}</span>
                            </div>
                        )
                    }
    
                    if (link.url !== null) {
                        if (link.label === 'Next &raquo;') {
                            return (
                                <Link key='next-btn' href={link.url} title={t('alts.next')} className="flex justify-center items-center hover:text-light-blue hover:opacity-80 transition-all ease-in-out duration-200">
                                    <span className="font-medium hidden md:block">{t('alts.next')}</span>
                                    <Icon icon='formkit:arrowright' width={20} className="ml-2" />
                                </Link>
                            )
                        }
    
                        if (link.label === '&laquo; Previous') {
                            return (
                                <Link key='prev-btn' href={link.url} title={t('alts.previous')} className="flex justify-center items-center hover:text-light-blue hover:opacity-80 transition-all ease-in-out duration-200">
                                    <Icon icon='formkit:arrowleft' width={20} className="ml-2" />
                                    <span className="text-black font-medium hidden md:block">{t('alts.previous')}</span>
                                </Link>
                            )
                        }
    
                        return (
                            <Link key={id} href={link.url} title={`${t('alts.page')} - ${link.label}`} className={resolveActiveClass(link.active)}>
                                <span className="text-18 font-bold">{link.label}</span>
                            </Link>
                        )
                    }
                })}
            </div>
        );
    }
}

export default FrontPagination;